import { DefaultInput, DefaultFormAutocomplete, DefaultFormSelect } from './index'
import AgreementResource from '../../resources/agreement'

const booleanSelectOptions = [
    { value: 1, text: 'Enabled' },
    { value: 0, text: 'Disabled' },
]

export default {
    agreement_id: new DefaultInput('Agreement'),
    agreement_id: new DefaultFormAutocomplete('Agreement', AgreementResource, 'agreement_id'),
    status: new DefaultFormSelect('Status', booleanSelectOptions, 'status'),
}
